<template>
  <div class="container mx-auto h-full py-5">
    <el-row :gutter="15">
      <el-col :span="24">
        <el-steps :active="active" finish-status="success" simple class="border bg-white">
          <el-step title="GENERALES" />
          <el-step title="DOCUMENTOS" />
          <el-step title="LABORAL" />
          <el-step title="CONFIRMACIÓN" />
        </el-steps>
      </el-col>
    </el-row>
    <el-row :gutter="15" type="flex" justify="center" class="my-8">
      <el-col :span="18">
        <div v-if="active === 0">
          <el-row :gutter="15" class="mb-5">
            <el-col :span="24" class="flex justify-center">
              <span
                class="uppercase font-semibold text-lg text-gray-800"
              >DATOS GENERALES DE LA NUEVA CONTRATACION</span>
            </el-col>
          </el-row>
          <NewTabGeneral @setCountry="setCountry" v-on:next="next" :values="form.general" />
        </div>
        <div v-if="active === 1">
          <el-row :gutter="15" class="mb-5">
            <el-col :span="24" class="flex justify-center">
              <span
                class="uppercase font-semibold text-lg text-gray-800"
              >DOCUMENTACIÓN DE LA NUEVA CONTRATACIÓN</span>
            </el-col>
          </el-row>
          <NewTabDocuments
            v-if="active === 1"
            @next="next"
            @back="back"
            :values="form.documents"
            :country="selectedCountry"
            :contractId="form.general.id"
          />
        </div>
        <div v-if="active === 2">
          <el-row :gutter="15" class="mb-5">
            <el-col :span="24" class="flex justify-center">
              <span
                class="uppercase font-semibold text-lg text-gray-800"
              >INFORMACION DEL PUESTO DE TRABAJO</span>
            </el-col>
          </el-row>
          <NewTabLaboral
            @next="next"
            @back="back"
            :values="form.laboral"
            :contractId="form.general.id"
          />
        </div>
        <div v-if="active === 3">
          <el-row :gutter="15" class="mb-5">
            <el-col :span="24" class="flex justify-center">
              <span
                class="uppercase font-semibold text-lg text-gray-800"
              >CONFIRMACIÓN DE LOS DETALLES</span>
            </el-col>
          </el-row>
          <NewTabOverview @back="back" :values="form" :contractId="form.general.id" />
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import NewTabGeneral from "./NewTabGeneral";
import NewTabDocuments from "./NewTabDocuments";
import NewTabLaboral from "./NewTabLaboral";
import NewTabOverview from "./NewTabOverview";

export default {
  name: "ContractNew",
  components: { NewTabGeneral, NewTabDocuments, NewTabLaboral, NewTabOverview },
  data() {
    return {
      active: 0,
      selectedCountry: null,
      form: {
        general: {
          name1: null,
          name2: null,
          lastname1: null,
          lastname2: null,
          dob: null,
          address1: null,
          address2: null,
          country: null,
          state: null,
          city: null,
          id: null,
        },
        documents: [],
        laboral: {
          contractType: null,
          department: null,
          position: null,
          contractStartDate: null,
          contractEndDate: null,
          paysheetType: null,
          currentSalary: null,
        },
      },
    };
  },
  methods: {
    next(value) {
      const { name, data } = value;
      this.form[name] = data;
      if (this.active++ > 3) this.active = 0;
    },
    back() {
      this.active--;
    },
    setCountry(country) {
      this.selectedCountry = country;
    },
  },
};
</script>
